"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GuessOpponent = void 0;
/**
 * Copyright (c) 2024 BrightSpike
 * All rights reserved.
 *
 * This source code is unlicensed.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 *
 * For detailed license information, please contact Brightspike at (info@brightspike.io).
 * @author Austin Weidler
 */
const pixi_js_1 = require("pixi.js");
const settings_1 = require("../config/settings");
const Global_1 = require("../Global");
const config_json_1 = __importDefault(require("../../../shared/config.json"));
const brushpoint_svg_1 = __importDefault(require("../../assets/svg/brushpoint.svg"));
const Opponent_1 = require("./Opponent");
const NameBanner_1 = require("./NameBanner");
const levels_1 = require("../../../shared/levels");
class GuessOpponent extends Opponent_1.Opponent {
    constructor(app, gameManager, pkey) {
        var _a;
        super(app, pkey);
        this.gameManager = gameManager;
        this.midscale = 0.333;
        this.endscale = 0.222;
        const n = this.pkey === this.gameManager.playerManager.pkey
            ? this.gameManager.playerManager.data.user : this.gameManager.opponent(this.pkey);
        const lvl = this.pkey === this.gameManager.playerManager.pkey
            ? this.gameManager.playerManager.data.lvl : (_a = this.gameManager.opponent(this.pkey)) === null || _a === void 0 ? void 0 : _a.lvl;
        this.banner = this.addChild(new NameBanner_1.NameBanner(app, n, lvl ? levels_1.levels[lvl - 1] : null, 120, 65));
        this.banner.color = settings_1.Settings.lightLightGrayColor;
        this.banner.score = this.score;
        this.banner.position.set((0, Global_1.px)(this.banner.w / 2), (0, Global_1.px)(this.banner.h / 2));
    }
    makeBrush() {
        const win = pixi_js_1.Sprite.from(brushpoint_svg_1.default);
        win.rotation = Math.PI;
        win.anchor.set(0.5);
        win.scale.set((0, Global_1.px)(this.endscale));
        win.position.set(this.banner.scorebox.width + (0, Global_1.px)(this.score > 0 ? 6 : 0), win.height / 2);
        return this.banner.scorebox.addChild(win);
    }
    inOverlay(color = settings_1.Settings.whiteColor, duration = 0.15) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.banner.inOverlay(color, duration);
        });
    }
    get score() {
        return Math.min(this.gameManager.score(this.pkey) || 0, config_json_1.default.guessscore);
    }
}
exports.GuessOpponent = GuessOpponent;
